import Link from 'next/link';
import { memo } from 'react';

import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import type { BlogArticleDocument } from '../../../../prismicio-types';

import styles from './articleCard.module.scss';

import { ClassicArrowRight } from '@/assets';
import { DateTopicInfo } from '@/components/DateTopicInfo/DateTopicInfo';
import { OptimizedPrismicImage } from '@/components/OptimizedPrismicImage/OptimizedPrismicImage';
import { BaseURL } from '@/types/articlesList';

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

interface ArticleCardProps {
  article: BlogArticleDocument<string>;
  baseUrl: BaseURL;
}

export const ArticleCardComponent = ({
  article,
  baseUrl,
}: ArticleCardProps) => {
  return (
    <Link href={`${baseUrl}${article.uid}`} className={styles.card}>
      <div className={styles.image_container}>
        <OptimizedPrismicImage
          field={article.data.image}
          className={styles.image}
        />
      </div>
      <div className={styles.content_wrapper}>
        <DateTopicInfo
          topic={article.data.topic}
          date={article.data.date}
          fontSize="small"
        />
        <PrismicRichText field={article.data.title} components={components} />
        <ClassicArrowRight />
      </div>
    </Link>
  );
};

export const ArticleCard = memo(ArticleCardComponent);
